/* import __COLOCATED_TEMPLATE__ from './output-text.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();